import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DimpleDivider from '@tds/core-dimple-divider';
import TextArea from '@tds/core-text-area';
import Heading from '@tds/core-heading';
import axios from 'axios';

import OrderComments from './orderComments';
import { Box } from '../../design/css';
import { apiHost, config } from '../../utils/request';
import { useLocaleContext } from '../../context/LocaleContext';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

const Comments = ({ comment, setComment, orderId, activeButton }) => {
  const locale = useLocaleContext();
  const [addedComments, setAddedComments] = useState([]);
  const {
    DEFECT_MANAGEMENT: { COMMENTS, ADD_COMMENT }
  } = locale === 'en-US' ? EN : FR;

  const onChangeComment = e => {
    setComment(e.target.value);
    if (e.target.value.length !== 0) {
      activeButton(true);
    } else {
      activeButton(false);
    }
  };

  const getComments = () => {
    axios.get(`${apiHost}/orders/${orderId}`, config()).then(data => {
      setAddedComments(data.data.comments);
    });
  };

  useEffect(() => {
    getComments();
  }, []);

  return (
    <>
      <DimpleDivider />
      <Heading level="h2" tag="h4">
        {COMMENTS}
      </Heading>
      <OrderComments data={addedComments} />
      <Box mt={10} />
      <TextArea
        label={ADD_COMMENT}
        value={comment}
        onChange={onChangeComment}
      />
    </>
  );
};

Comments.propTypes = {
  comment: PropTypes.string.isRequired,
  setComment: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired,
  activeButton: PropTypes.bool.isRequired
};

export default Comments;
